import React from 'react';
import * as Icons from 'lucide-react';

const ServicesSection = ({ data }) => {
  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-10 md:mb-12">
          {data.title}
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {data.services.map((service, index) => {
            const IconComponent = Icons[service.icon] || Icons.Circle;
            return (
              <div 
                key={index} 
                className="flex flex-col items-center text-center p-5 sm:p-6 bg-[#f9fafb] rounded-xl"
              >
                <div className="w-12 h-12 bg-[#1a1f4e]/10 rounded-xl flex items-center justify-center mb-4">
                  <IconComponent className="w-6 h-6 text-[#1a1f4e]" strokeWidth={1.5} />
                </div>
                <span className="text-gray-700 font-medium text-sm sm:text-base leading-snug">{service.label}</span>
              </div>
            );
          })}
        </div>
        
        {/* Clarity Line */}
        <p className="text-center text-gray-600 mt-10 text-sm sm:text-base leading-relaxed max-w-xl mx-auto">
          All shared internal areas maintained on a fixed rota.
        </p>
        
        {/* Exclusion Line with Bold */}
        <p className="text-center text-gray-500 text-xs sm:text-sm mt-3">
          This is full communal area cleaning — <strong className="text-gray-700 font-medium">not domestic or one-off cleans.</strong>
        </p>
      </div>
    </section>
  );
};

export default ServicesSection;
